import { activePortalSettings } from './portal-regions';
export const maintenanceConfig = {
    enabled: activePortalSettings.maintenanceMode === true,
};
